// extracted by mini-css-extract-plugin
module.exports = {"grid":"About_grid__3_V84","content":"About_content__2Z8Ps"};